<template>
  <div class="view-account">
    <subscriptions-view v-if="user" />

    <div class="mt-auto">
      <hr class="mt-7" />
      <order-history :open="false" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useUser } from "@/api/user.store";

import SubscriptionsView from "@manager/subscriptions/SubscriptionsView.vue";
import OrderHistory from "../subscriptions/OrderHistory.vue";

const { user } = useUser();
</script>

<style lang="scss">
.view-account {
  display: grid;
  grid-template-rows: 1fr auto;
  min-height: 100%;
}
</style>
